import "core-js/modules/es.array.concat.js";
export function getAdminContentLink(item) {
  var _localStorage$getItem;
  if (item.type === 'playlist') {
    if (item.isDeleted) {
      return "/playlists/".concat(item.id, "?search=").concat(encodeURIComponent("id:".concat(item.id, " is:deleted")));
    }
    return "/playlists/".concat(item.id, "?search=id:").concat(item.id);
  }
  if (item.type === 'section') {
    var _item$parentPlaylistI, _item$assetCollection, _item$assetCollection2, _item$assetCollection3;
    var parentPlaylistId = (_item$parentPlaylistI = item.parentPlaylistId) !== null && _item$parentPlaylistI !== void 0 ? _item$parentPlaylistI : (_item$assetCollection = item.assetCollections) === null || _item$assetCollection === void 0 ? void 0 : (_item$assetCollection2 = _item$assetCollection[0]) === null || _item$assetCollection2 === void 0 ? void 0 : (_item$assetCollection3 = _item$assetCollection2.collectionAsset) === null || _item$assetCollection3 === void 0 ? void 0 : _item$assetCollection3.id;
    if (parentPlaylistId) {
      return "/playlists/".concat(parentPlaylistId, "/content?content-selection=").concat(item.id);
    }
    return '';
  }
  if (item.domain_id && item.domain_id !== +((_localStorage$getItem = localStorage.getItem('domainId')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 0)) {
    return "/assets?search=id:".concat(item.id, " owner:common");
  }
  var parentId = item.parent_id ? "/".concat(item.parent_id) : '';
  return "/assets".concat(item.type === 'folder' ? "/".concat(item.id) : parentId, "?id=").concat(item.id).concat(item.isDeleted ? "&search=is:deleted".concat(item.type !== 'folder' ? " id:".concat(item.id) : '') : '');
}